import { Component, OnInit } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { EntertainmentService } from './entertainment.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { EntertainmentIptvComponent } from './iptv/entertainment-iptv.component';
import { EntertainmentInternetComponent } from './internet/entertainment-internet.component';
import { EntertainmentAppComponent } from './entertainment-app/entertainment-app.component';
@Component({
  selector: 'app-entertainment',
  templateUrl: './entertainment.component.html',
  styleUrls: ['./entertainment.component.scss'],
})
export class EntertainmentComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  activatedComponentRef: any;
  selectionInfo: SelectionInfo;
  active: number;
  private sub = new Subscription();
  private activeComponentTab: any;
  permissionSelectConsole = 'hasEntertainment';
  selectedConsoleTypeRights = {
    hasTVSetting: 'false',
    hasInternetSetting: 'false',
  };
  currentSelectedTab = '';
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
    private _loader: HaloLoaderService
  ) {}

  ngOnInit(): void {
    this._setDefaultTab();
    this._trackingChangingRoutes();
    const getRootScopeSub = this.rootScopeService
      .getRootScope()
      .subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
    this.sub.add(getRootScopeSub);
  }

  navigateToChild(childPath: string): void {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.pathToNavigate = '/equipmentSettings/entertainment/' + childPath;
      this.rootScopeData.showUnSavedChangesModal = true;
      setTimeout(() => {
        this._setDefaultTab();
      });
    } else {
      this.currentSelectedTab = childPath;
      this.rootScopeData.isPageHasUnsavedChanges = false;
      this._router.navigate([childPath], { relativeTo: this._route });
    }
  }

  private _trackingChangingRoutes(): void {
    const routes = this._router.events.subscribe((val: any) => {
      if (val.url === '/equipmentSettings/entertainment/iptv' || val.url === '/iptv') {
        this.active = 1;
      } else if (val.url === '/equipmentSettings/entertainment/internet' || val.url === '/internet') {
        this.active = 2;
      }
    });
    this.sub.add(routes);
  }

  private _setDefaultTab(): void {
    if (
      this._router.routerState.snapshot.url === '/equipmentSettings/entertainment/iptv' ||
      this._router.routerState.snapshot.url === '/iptv'
    ) {
      this.active = 1;
    } else {
      this.active = 2;
    }
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      if (selectionInfo.facility.summary?.facilityRights.software === 'true') {
        this.activeComponentTab?.onSelectionChange(this.selectionInfo);
      } else {
        this.commonUtil.redirectToAvailablePage();
      }
      let consoleRights = this.commonUtil.rootScopeData?.consoleRights?.get(this.selectionInfo.consoleType);
      this.selectedConsoleTypeRights = {
        hasTVSetting: consoleRights.hasTVSetting,
        hasInternetSetting: consoleRights.hasInternetSetting,
      };
      if (
        this.selectedConsoleTypeRights.hasTVSetting !== 'true' &&
        this.selectedConsoleTypeRights.hasInternetSetting !== 'true'
      ) {
        this.commonUtil.redirectToAvailablePage();
      } else {
        if (
          ['tv', 'iptv'].includes(this.currentSelectedTab) &&
          this.selectedConsoleTypeRights.hasTVSetting !== 'true'
        ) {
          this.currentSelectedTab = 'apps';
          this._router.navigate(['apps'], { relativeTo: this._route });
        }

        if (
          ['apps', 'internet'].includes(this.currentSelectedTab) &&
          this.selectedConsoleTypeRights.hasInternetSetting !== 'true'
        ) {
          this.currentSelectedTab = 'tv';
          this._router.navigate(['tv'], { relativeTo: this._route });
        }
      }
    });
  }

  private onTabActivated(componentRef: any) {
    if (componentRef instanceof EntertainmentIptvComponent || componentRef instanceof EntertainmentInternetComponent) {
      this.activeComponentTab = componentRef;
      componentRef.onSelectionChange(this.selectionInfo);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this._loader.endProcess();
  }
}
